export const first = value => (Array.isArray(value) ? value[0] : value) || {};

export const isEnabled = value => [true, 1, '1'].includes(value);

export const payloadOf = event => event?.payload || {};

export const textOf = (value, empty, t) => {
  if (value === true) return t('POST_SALE.STATUS_DETAILS.YES');
  if (value === false) return t('POST_SALE.STATUS_DETAILS.NO');
  if (value === null || value === undefined || value === '') return empty;
  if (typeof value === 'object') {
    return value.name || value.nome || value.label || value.sub_topico || empty;
  }

  return String(value);
};

export const listOf = (value, empty, t) => {
  if (!Array.isArray(value)) return textOf(value, empty, t);

  return value.map(item => textOf(item, empty, t)).join(', ') || empty;
};

export const rgiLabel = (value, empty, t) =>
  ({ 1: '2º', 2: '3º', 3: '5º', 4: '9º', 5: '11º', 6: '10º' })[value] ||
  textOf(value, empty, t);

export const laudemiumLabel = (entry, t) => {
  const type = entry?.nome_tipo_laudemio;
  const name = entry?.nome_lista_laudemio;

  if (type === 'União') {
    return t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_UNION', { name });
  }
  if (type === 'Familia do imóvel') {
    return t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_FAMILY', { name });
  }
  if (type === 'Prefeitura') {
    return t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_CITY_HALL');
  }

  return t('POST_SALE.STATUS_DETAILS.LAUDEMIUM_CHURCH', { name });
};

export const deedAddress = deed =>
  [
    deed?.cep,
    deed?.logradouro || deed?.endereco_escritura,
    deed?.numero || deed?.numero_escritura,
    deed?.unidade || deed?.unidade_escritura,
    deed?.complemento || deed?.complemento_escritura,
    deed?.cidade || deed?.cidade_escritura,
    deed?.uf || deed?.estado_escritura,
    deed?.bairro || deed?.bairro_escritura,
  ]
    .filter(Boolean)
    .join(', ');
